import { SagaIterator } from 'redux-saga'
import { fork, put, takeEvery, call } from 'redux-saga/effects'
import { DataAction } from '../../actions/commons'
import {
  BILLING_GUIDE_FETCH_POSTCODES,
  fetchPostcodesSuccess,
  fetchPostcodesFail,
} from '../../actions/BillingGuideActions/billingGuideActions'
import { get, ResponseStatus, ResponseWithStatus } from '../../fetch'
import { SuggestResponse } from '../../domain/models/rest/SearchResponse'
import text from '../../_constants/text'

const ELASTIC_URL = process.env.REACT_APP_IMED_WEBSITE_ELASTIC_URL

// Type for the raw API response
type PostcodeResponse = {
  Postcode: string
  Suburb: string
  'CRM CMS ID': string
  lat: number
  lon: number
}

export function* fetchPostcodesSaga(action: DataAction<{ postcode: string }>): SagaIterator {
  try {
    const params = {
      index: 'postcode',
      mode: 'suggest',
      size: '50',
      q: action.data.postcode.toUpperCase(),
      // If the input is purely numeric, search by Postcode field; otherwise, search by Suburb field
      field: /^\d+$/.test(action.data.postcode) ? 'Postcode' : 'Suburb.keyword',
    }

    const response = (yield call(
      get<SuggestResponse<PostcodeResponse>>,
      ELASTIC_URL,
      {},
      params,
    )) as ResponseWithStatus<SuggestResponse<PostcodeResponse>>

    if (response.status !== ResponseStatus.SUCCESS) {
      console.warn('API error while fetching billing guide postcodes:', response.status)
      yield put(fetchPostcodesFail(text.BILLING_GUIDE_POSTCODE_ERROR_MESSAGE))
      return
    }

    const data: SuggestResponse<PostcodeResponse> = response.data

    // Extract postcode suggestions from Elasticsearch response
    const postcodes =
      data.hits?.hits?.map((hit) => ({
        _id: hit._id,
        _source: {
          postcode: hit._source.Postcode,
          suburb: hit._source.Suburb,
          lat: hit._source.lat,
          lon: hit._source.lon,
        },
      })) || []

    yield put(fetchPostcodesSuccess(postcodes))
  } catch (error) {
    console.error('Unexpected error while fetching billing guide postcodes:', error)
    yield put(fetchPostcodesFail(text.BILLING_GUIDE_POSTCODE_ERROR_MESSAGE))
  }
}

function* watchFetchPostcodes(): SagaIterator {
  yield takeEvery(BILLING_GUIDE_FETCH_POSTCODES, fetchPostcodesSaga)
}

const postcodeSaga = [fork(watchFetchPostcodes)]

export default postcodeSaga
